import {createStore} from 'vuex'
import modulesPaths from '@moeinmdn/mixitweb-front-modules/src/plugin/store'

export default createStore({
    modules: {
        ...modulesPaths,

    }
})
